<template>
    <div class="inner-box">
      <div slot="content">
        <el-form size="medium" @submit.prevent="save">
          <div class="content-name">
            <h2 class="dp-ib">{{ routeName }}</h2>
            <el-form-item label-width="0px" style="float: right;">
              <el-button type="primary" icon="el-icon-search" @click="goOpen">
                {{ this.$i18n.messages[this.$store.state.locale].search }}
              </el-button>
              <el-button type="primary" icon="el-icon-search" @click="openUpdate">
                요청자재등록
              </el-button>
              <el-button type="danger" icon="el-icon-delete-solid" @click="deleteRow">
                선택삭제
              </el-button>
            </el-form-item>
          </div>
        </el-form>
  
        <div class="search-form">
          <el-form size="mini">
            <el-row style="margin-bottom: 0px;">
              <el-col :span="12">
                <el-form-item label="요청일자" label-width="100px">
                  <el-row>
                    <el-col>
                      <el-col :span="11">
                        <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-col>
                      <el-col :span="1" style="text-align: start;">-</el-col>
                      <el-col :span="12">
                        <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-col>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="요청구분" label-width="100px">
                    <el-select v-model="form.requestType" >
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['RequestType']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="진행단계" label-width="100px">
                    <el-select v-model="form.procYn" >
                        <el-option value='' label="전체">전체</el-option>
                        <el-option value='NN' label="요청대기"></el-option>
                        <el-option value='YN' label="출고확정"></el-option>
                        <el-option value='YY' label="입고완료"></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="요청기사" label-width="100px">
                  <el-input v-model="form.requestUserNm" readonly>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="제조사" label-width="100px">
                    <el-select v-model="form.maker" >
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['Maker']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="제품군" label-width="100px">
                    <el-select v-model="form.itemGroup" >
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['ModelGroup']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="품번" label-width="100px">
                  <el-input type="text" v-model="form.itemCd"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="table-area">
        <div class="table-b">
          <div class="table-header">
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="grid"
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  :enableRangeSelection="true"
                  :column-defs="columnDefs"
                  :grid-options="mainGridOptions"
                  :row-data="data"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  :context="context"
                  :statusBar="statusBar"
                  @grid-ready="onReadyMain"
                  @cell-clicked="onCellClicked" />
            </div>
          </div>
        </div>
      </div>
      <div class="btn-type1 clearfix">
        <button class="btn-size btn-blue" @click="subUpdate">
          수정
        </button>
      </div>
      <div class="table-area">
        <div class="table-b">
          <div class="table-header">
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="grid"
                  :style="gridStyle2"
                  class="ag-theme-alpine"
                  row-selection="single"
                  :column-defs="columnDefs2"
                  :grid-options="mainGridOptions2"
                  :row-data="dataSub"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  :stopEditingWhenCellsLoseFocus="true"
                  @grid-ready="onReadyMain"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
  import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
  import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
  import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
  import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
  import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
  import InputCellRender from "@/components/agGrid/input-cell-renderer";
  import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
  import ReqMateEnter from "@/components/LucomsModal/ReqMateEnter";
  import ReceptionModal_01 from "@/components/AS/History/Modal/ReceptionModal_01";
  
  function _url(...args) {
    args = args.map(x =>
        String(x || "")
            .trim()
            .replace(/^\/*|\/*$/g, "")
    );
    return args.filter(x => x).join("/");
  }
  
  export default {
    props: {
    },
    data() {
      return {
        data: [],
        dataSub: [],
        parentId: "0",
        form: {
              companyId : '',
              startDt: this.$moment().subtract(7, 'days').format('YYYY-MM-DD'),
              endDt: this.$moment().format('YYYY-MM-DD'),
              requestUserId: 0,
              requestType : '',
              procYn : '',             // 처리상태
              maker : '',              // 제조사
              itemGroup : '',          // 제조사
              itemCd : '',             // 품번
              asAgentId : 0,        
              sortType : '',           // 승인/정산처리유형
              page : 1,
              totalPage : 9999,
              curPage : 1,
              totalCount : 9999,
              processTime : ''
        },
        combos: {
        'RequestType': [],
        'Maker': [], //제조사
        'ModelGroup': [], //제품군
        'ModelDetail': [], //제품군 select,
        },
        gridStyle : 'padding-top: 40px; width: 100%;height: 550px; min-height:100px;',
        gridStyle2 : 'padding-top: 40px; width: 100%;height: 150px; min-height:100px;',
        context: {
            headerAllCheckEvent: this.allCheckEvnet,
        },
        defaultColDef: {
            resizable: true
          , filter:false
          , sortable: true
        },
        mainGridApi: null,
        mainColumnApi: null,
        mainGridOptions: {
          enableColResize: true,
          enableFilter: true,
          animateRows: false,
          enableSorting: true,
        },
        mainGridOptions2: {
          enableColResize: true,
          enableFilter: true,
          enableSorting: true,
        },
        columnDefs: [],
        columnDefs2: [],
        frameworkComponent : {
          datePicker: DatepickerCellRenderer,
          maskEdit: MaskEditCellRenderer,
          select: SelectCellRenderer,
          checkBox: CheckboxCellRenderer,
          radio: RadioCellRenderer,
          numberInput: NumberInputCellRender,
          input: InputCellRender,
          button: ButtonCellRenderer
        },
        statusBar: null,
        buttonDisable: false
      }
    },
    methods: {
      onReadyMain() {
        this.mainGridApi = this.mainGridOptions.api;
        this.mainColumnApi = this.mainGridOptions.columnApi;
  
        this.init();
      },
      createMainColumnDefs() {
        const vm = this;
        this.columnDefs = [
          {
            field:'chk', 
            width:80,
            headerComponent: `checkBox`,
            headerComponentParams: (params) => {
              return params;
            },
            cellStyle : {textAlign: 'center'},
            cellRenderer: 'checkBox',
            cellRendererParams: (params) => {
                return {
                  trueValue: 'Y',
                  falseValue: 'N',
                  disable: params.data.outDt === null ? false: true
              }
            }
          },
          {headerName:'요청일시', field:'requestDt', width:170, cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return vm.getDateTimeFormat(`${params.value}`)
          }},
          {headerName:'요청구분', field:'requestType', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'요청품번', field:'itemCd', width:120, cellStyle:{textAlign: 'center'}},
          {headerName:'요청품명', field:'itemNm', cellStyle:{textAlign: 'center'}, width:160},
          {headerName:'요청수량', field:'goodQty', width:110, cellStyle:{textAlign: 'right'} },
          {headerName:'사이트', field:'siteNm1', width:250, cellStyle:{textAlign: 'center'}},
          {headerName:'구분', field:'srcId2', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'접수번호', field:'outItemRequestId', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'출고', field:'outAsAgentNm', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'입고', field:'requestAsAgentNm', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'출고일자', field:'outDt', width:110, cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return vm.getDateFormat(`${params.value}`)
          }},
          {headerName:'출고수량', field:'inGoodQty', width:110, cellStyle:{textAlign: 'right'}},
          {headerName:'본사재고', field:'invtGoodQty', width:110, cellStyle:{textAlign: 'right'}},
          {headerName:'진행단계', field:'procYnNm', width:110, cellStyle:{textAlign: 'center'}},
        ];
      },
      createMainColumnDefs2(data) {
        const sub = data;
        this.columnDefs2 = [
          {headerName:'진행단계', field:'procYnNm', width:110, cellStyle: {textAlign: 'center'}},
          {headerName:'요청일시', field:'requestDt', width:170, cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return this.getDateTimeFormat(`${params.value}`)
            }
          },
          {headerName:'요청구분', field:'requestType', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'제조사', field:'makerNm', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'제품군', field:'itemGroupNm', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'품번', field:'itemCd', width:180, cellStyle:{textAlign: 'center'}},
          {headerName:'품명', field:'itemNm', cellStyle:{textAlign: 'center'}, width:200},
          {headerName:'요청수량', field:'goodQty', width:130,cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'},
            editable: (params)=>{return params.data.requestType == "사용자재" ? false : true; },
            valueFormatter: (params) => {
              return this.getNumberFormat(params.value);
            }},
          {headerName:'메모', field:'memo', width:180,cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'},
            editable: (params)=>{return params.data.requestType == "사용자재" ? false : true; },
            valueFormatter: (params) => {
              return params.value;
            }
          }
        ];
      },
      /**
       * grid 내에 체크박스 전체 체크 함수
       * @param {*} field 
       * @param {*} checked 
       */
      allCheckEvnet(field, checked) {
        return this.data = this.data.map(x => {
            if(!x.outDt) {
                x[field] = checked ? 'Y' : 'N';
            }
            return x;
        })
      },
      onCellClicked(params) {
        const field = params.colDef.field;
        this.goDetail(params.data);
      },
      getDateFormat(val) {
        if (val) {
          return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
        }
      },
      getDateTimeFormat(val) {
        if (val) {
          return val === 'null' ? '' : this.$moment(val).format('yyyy-MM-DD HH:mm:ss')
        }
      },
      getNumberFormat(val) {
        if (val) {
          if (this.dataSub.requestType === "사용자재") {
            return val;
          }
          else {
            if(typeof val === "string"){
              val = val.replace(/[^0-9]/g, "")
            }
            return Math.floor(val).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          }
        }
      },
      openModel(param) {
        console.log(param);
        let vm = this;
        this.$modal.open({
          width: 800,
          component: ReceptionModal_01,
          parent: this,
          props: {
            data: {
              asId: param.asId,
              custId: param.custId,
              sortType: '',
              popHeadInfo: '', //this.custParam.popHeadInfo,
              //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
              recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
              procsDt: this.$moment(param.procDt).format('YYYY-MM-DD')
            }
          },
          events: {
            close(data) {
              console.log('close', data);
            },
          }
        });
      },
      $dismiss() {
        this.$emit('dismiss')
        this.$parent.close()
      },
      goOpen() {
        let that = this
        this.$store.commit('loading')
        this.$http.post(_url("/api/agent/reqMateList/list"), this.form).then(response => {
          this.data = response.data;
          this.changeData();
        }).finally(() => {
          this.$store.commit('finish')
        });
      },
      changeData() {
        this.data.map((x, i) => {

          if(x.moveStatus === null || x.moveStatus === '') {
            if (x.procYn == "NN") { x.procYnNm = "요청대기" }
            else if (x.procYn == "YY") { x.procYnNm = "입고완료" }
            else { x.procYnNm = "출고확정" }
          }
          else {
            if ( x.procYn == "YY" ) { x.procYnNm = "입고완료" }
            else { x.procYnNm = "출고확정" }
          }

          let filterRequestType = this.combos['RequestType'].filter(y => y.key === x.requestType);
          x.requestType = filterRequestType[0]?.value;

          let srcId2Data = x.srcId2 !== "" ? "AS" : "";
          x.srcId2 = srcId2Data;
        })
      },
      goDetail(param) { // 요청자재정보 수정 정보 가져오기
        let vm = this
        const vForm = {
          companyId: this.$store.state.loginInfo.compCd,
          productType: param.productType,
          outItemRequestId: param.outItemRequestId
        }
        this.$http.post(_url("/api/agent/reqMateList/item/list"), vForm).then(response => {
          this.dataSub = response.data;
          this.changeDataSub();
          this.createMainColumnDefs2(response.data)
        }).finally(() => {
          this.$store.commit('finish')
        });
      },
      changeDataSub() {
        this.dataSub.map((x, i) => {
          let filterRequestTYpe = this.combos['RequestType'].filter(y => y.key === x.requestType);
          x.requestType = filterRequestTYpe[0]?.value;

          if (x.procYn == "NN") { x.procYnNm = "요청대기" }
          else if (x.procYn == "YY") { x.procYnNm = "입고완료" }
          else { x.procYnNm = "출고확정" }

          if (x.requestType !== "사용자재") {this.buttonDisable = true}
          else {this.buttonDisable = false}
        })
      },
      openUpdate() { // 요청자재등록
        const vm = this

        this.$modal.open({
          component: ReqMateEnter,
          parent: this,
          props: {
          },
          events: {
            close(data) {
            },
          }
        });
      },
      subUpdate() {
        let res = this.dataSub[0];

        let updateForm = {
          productType: 'Item',
          outItemRequestId: res.outItemRequestId,
          goodQty: res.goodQty,
          memo: res.memo,
          updatorId: this.$store.state.loginInfo.id
        }

        this.$swal({
          type: 'warning',
          text: '요청자재정보를 수정 하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니요',
        }).then((res) => {
          if(res.value) {
            this.$store.commit('loading')
            this.$http.post('/api/agent/reqMateList/update', updateForm)
              .then(response => {
                this.$swal({type: 'success', text: '수정을 완료 하였습니다.'});
                  this.goOpen();
              }).catch((e) => {
                this.$swal({type: 'warning', text: '수정 실패 했습니다.'})
              }).finally(() => {
                this.$store.commit('finish');
              });
          }
        })
      },
      deleteRow() {
        var list = this.data.filter(y =>  y.chk === 'Y')

        if (list.length > 0) {
          let result = [];
          let deleteForm = {};

          list.forEach(x => {
            deleteForm = {
              productType: 'Item',
              outItemRequestId: x.outItemRequestId,
              updatorId: this.$store.state.loginInfo.id
            }
            result.push(deleteForm);
          })
          this.$swal({
            type: 'warning',
            text: '선택한 요청자재를 삭제 하시겠습니까?',
            showCancelButton: true,
            confirmButtonText: '예',
            cancelButtonText: '아니요',
          }).then((res) => {
            if (res.value) {
              this.$store.commit('loading')
              this.$http.post(("/api/agent/reqMateList/delete"), result).then(r => {
                this.$swal({type: 'success', text: '요청자재를 삭제하였습니다.'})
                    .then(res => {
                      if (res) {
                        this.goOpen();
                        this.dataSub = null;
                      }
                    })
              }).catch((e) => {
                this.$swal({type: 'warning', text: '요청자재 삭제 실패 했습니다.'})
              }).finally(() => {
                this.$store.commit('finish')
              });
            }
          })
        }
        else {
          this.$swal({
            type: 'warning',
            text: '요청자재를 선택해 주십시요.'
          });
        }
      },
      async init() {
        this.$store.commit('loading');
        await this.$http.post(`/api/agent/reqMateList/init`)
          .then(response => {
            this.combos['RequestType'] = response.data.requestType; //요청구분
            this.combos['Maker'] = response.data.maker;
            this.combos['ModelGroup'] = response.data.itemGroup;
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });
        this.createMainColumnDefs();
      },
    },
    created() {
      this.statusBar = {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'right' },
        ],
      };
    },
    mounted() {
      this.form.companyId = this.$store.state.loginInfo.compCd;
      this.form.requestUserNm = this.$store.state.loginInfo.userName;
      this.form.asAgentId = this.$store.state.loginInfo.asAgentId;
      this.form.requestUserId = this.$store.state.loginInfo.id;
    },
    computed: {
      routeName() {
        return this.$route.name
      }
    },
  }
  </script>
  
  
  <style lang="scss" scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  </style>